<template>
  <VueSelect
    :invalid="allErrors[name] !== undefined"
    :id="name"
    :model-value="modelValue"
    :options="addressOptions"
    :filterable="false"
    :data-test="dataTest"
    :placeholder="placeholder"
    :disabled="disabled"
    :name="name"
    label="tekst"
    :class="{ invalid: allErrors[name] !== undefined }"
    @search="getAddressOptions"
    @update:model-value=" localModelValue = $event; $emit('update:model-value', $event);"
  >
    <template #no-options>
      {{ placeholder }}
    </template>
  </VueSelect>
</template>

<script>
import RequestService from '@/common/requestService';
import Utility from '@/common/UtilityFunctions.js';

import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default {
  name: 'AddressSearch',
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  emits: ['update:model-value'],
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    },
    dataTest: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    zipCode: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default() {
        return 'address';
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      addressOptions: [],
      localModelValue: this.modelValue
    };
  },
  computed: {
    zipCodeString() {
      return this.zipCode !== '' ? '&postnr=' + this.zipCode : '';
    },
    allErrors() {
      return this.errors ?? this.form?.errors ?? {};
    }
  },
  methods: {
    getAddressOptions(search, loading) {
      if (search !== '') {
        loading(true);
        RequestService.get(
          Utility.constants().externalAPI.dawa_adresser + search + this.zipCodeString
        )
          .then((resp) => {
            this.addressOptions = resp.data;
            // this.$validator.errors.removeById('connectectionError');
          })
          .catch((err) => {
            if (err.message === 'Network Error') {
              // this.$validator.errors.add({
              //   field: this.name,
              //   msg: 'Der er ikke forbindelse til adresseregisteret. Prøv igen om lidt.',
              //   rule: 'required',
              //   scope: undefined,
              //   id: 'connectectionError'
              // });
            } else {
              Utility.logError(err, this);
            }
          })
          .finally(() => {
            loading(false);
          });
      } else if (this.selected !== null) {
        this.addressOptions = [this.selected];
      }
    }
  }
};
</script>
